import React from 'react';
import Button from '@mui/material/Button';
import { Grid, Paper } from '@mui/material';
import { Form, Formik } from 'formik';
import InputForm from '../../commun/input-form';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import '../filter-form.scss';
import { CompositionFormDto } from '../../../services/dtos/composition-form.dto';

/**
 * Compsant qui permet de rechercher les compositions
 * @constructor
 * @param props
 */
export default function CompositionForm(
    props: Readonly<{ handlerSearch: (e: CompositionFormDto) => void; searching: boolean }>
) {
    //Initialisation des valeurs
    const iniValues: CompositionFormDto = {
        name: '',
        title: '',
        localAuthority: '',
    };

    return (
        <Formik
            initialValues={iniValues}
            onReset={() => props.handlerSearch(iniValues)}
            onSubmit={values => props.handlerSearch(values)}
        >
            <Form>
                <Paper className="filter-form" elevation={0}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={3}>
                            <InputForm autoFocus id="name" name="name" label="Nom de l'élu" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <InputForm id="title" name="title" label="Titre" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <InputForm id="localAuthority" name="localAuthority" label="Collectivité" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <div className="filter-form__actions">
                                <Button
                                    type="reset"
                                    variant="outlined"
                                    className="filter-form__button filter-form__button--reset"
                                    startIcon={<ClearIcon />}
                                >
                                    Annuler
                                </Button>
                                <Button
                                    data-testid={'search-composition'}
                                    type="submit"
                                    variant="contained"
                                    className="filter-form__button"
                                    startIcon={<SearchIcon />}
                                    disabled={props.searching}
                                >
                                    {props.searching ? 'Recherche...' : 'Rechercher'}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </Form>
        </Formik>
    );
}
